import type { PromptRequirements } from "@/lib/api/types";
import { TRIGGER_MAX, triggerLines } from "@/lib/prompt-module";

type Props = {
  req: PromptRequirements;
  count: number;
  busy: boolean;
  error: string | null;
  onStart: () => void;
  onCancel: () => void;
};

/** Rückfrage vor dem Trigger-Test: Umfang und geschätzte Kosten stehen vor dem Start da. */
export function TriggerDialog({ req, count, busy, error, onStart, onCancel }: Props) {
  const tooMany = count > TRIGGER_MAX;
  return (
    <div
      role="group"
      aria-label="Trigger-Test bestätigen"
      className="flex flex-col gap-3 rounded-lg border border-line bg-white px-5 py-4 text-sm"
    >
      <h2 className="text-base font-semibold">Trigger-Test starten?</h2>
      <p className="text-[13px] text-muted">
        Jeder Prompt läuft mehrfach in ChatGPT und Gemini, jeweils mit Websuche. Gemessen werden Websuche, Quellen, ob deine Domain
        zitiert wird und welche Marken in den Antworten vorkommen. Nur Prompts mit Quellenbezug sind für GEO messbar.
      </p>
      <ul className="flex flex-col gap-0.5">
        {triggerLines(req, count).map((line) => (
          <li key={line}>{line}</li>
        ))}
      </ul>
      {tooMany && (
        <p role="alert" className="text-[13px] text-danger">
          Höchstens {TRIGGER_MAX} Prompts je Test. Wähle weniger Prompts aus.
        </p>
      )}
      {error && (
        <p role="alert" className="text-[13px] text-danger">
          {error}
        </p>
      )}
      <div className="flex flex-wrap gap-2">
        <button
          type="button"
          disabled={busy || tooMany || count === 0}
          onClick={onStart}
          className="h-11 rounded-md bg-accent px-3.5 text-sm font-medium text-white disabled:opacity-60"
        >
          {busy ? "Wird gestartet …" : "Trigger-Test starten"}
        </button>
        <button type="button" onClick={onCancel} className="h-11 rounded-md border border-field bg-white px-3.5 text-sm">
          Abbrechen
        </button>
      </div>
    </div>
  );
}
